import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 5.25H11.25V18.75H5C4.58579 18.75 4.25 18.4142 4.25 18V16.75H3.25V18C3.25 18.4142 2.91421 18.75 2.5 18.75C2.08579 18.75 1.75 18.4142 1.75 18V7C1.75 6.58579 2.08579 6.25 2.5 6.25C2.91421 6.25 3.25 6.58579 3.25 7V9.25H4.30888C4.66846 6.98301 6.63185 5.25 9 5.25ZM4.25 10.75H3.25V15.25H4.25V10.75ZM10 10.25C10.4142 10.25 10.75 10.5858 10.75 11V13C10.75 13.4142 10.4142 13.75 10 13.75C9.58579 13.75 9.25 13.4142 9.25 13V11C9.25 10.5858 9.58579 10.25 10 10.25Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 18.75H12.75V5.25H15C17.3682 5.25 19.3315 6.98301 19.6911 9.25H20.75V7C20.75 6.58579 21.0858 6.25 21.5 6.25C21.9142 6.25 22.25 6.58579 22.25 7V18C22.25 18.4142 21.9142 18.75 21.5 18.75C21.0858 18.75 20.75 18.4142 20.75 18V16.75H19.75V18C19.75 18.4142 19.4142 18.75 19 18.75ZM19.75 15.25H20.75V10.75H19.75V15.25ZM14 10.25C14.4142 10.25 14.75 10.5858 14.75 11V13C14.75 13.4142 14.4142 13.75 14 13.75C13.5858 13.75 13.25 13.4142 13.25 13V11C13.25 10.5858 13.5858 10.25 14 10.25Z"
        fill={colorValue}
      />
    </svg>
  );
};
